import BranchTicketsPerService from "../../../components/branches/reports/daily/BranchTicketsPerService";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { TICKETS_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyBranchTicketsPerService = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    branchScoped={true}
    reportTypeId={REPORT_TYPE_IDS.daily_branch_tickets_per_service}
    title="Tickets Per Service"
    helmetTitle="Daily Branch Tickets Per Service"
    descriptionKey="TicketsPerServiceBranches"
    columnDefinitions={TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) =>
      data.map((item, index) => (
        <BranchTicketsPerService
          key={index}
          branchId={item.branchId}
          branchIndex={index + 1}
          data={item.serviceData}
          numServices={item.numServices}
          branchName={item.branchName}
          renderConfig={renderConfig}
          onRenderConfigChange={onRenderConfigChange}
        />
      ))
    }
  </DailyGeneratedReportPage>
);

export default DailyBranchTicketsPerService;
